var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('compFormQuery',{staticClass:"margin-layout",attrs:{"formdata":_vm.getBase,"value":_vm.formData}}),_c('vLoading',{attrs:{"size":"large","fix":"","loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }